function Storage(){
  var self = this;
  if (typeof localStorage === "undefined") {
    var LocalStorage = require('node-localstorage').LocalStorage;
    self.store = new LocalStorage('./scratch');
  }
  self.browser = null;
  if (typeof localStorage !== "undefined") {
    self.store = localStorage;
  }
}

module.exports = Storage;
